import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { FIELD_PATH_APPEARANCE } from 'components/page/DatingProfile/DatingProfile.constants'
import { ProfileFieldType } from 'components/page/ProfileCommon/ProfileCommon.types'
import { ProfileFieldGeneric } from 'components/page/ProfileCommon/ProfileField/ProfileFieldGeneric'
import { AppearanceActiveSvg } from 'components/presentational/svg/AppearanceActiveSvg'
import { AppearanceDefaultSvg } from 'components/presentational/svg/AppearanceDefaultSvg'
import {
  GQLDatingProfileLexicalOptionType,
  GQLAppearance,
} from 'generated-graphql/graphql'

interface ProfileSmokingProps {
  data: GQLAppearance | null | undefined
  lexemes: GQLDatingProfileLexicalOptionType[]
}

export const ProfileAppearance: FC<ProfileSmokingProps> = ({
  data,
  lexemes,
}) => {
  return (
    <ProfileFieldGeneric
      iconDefault={<AppearanceDefaultSvg />}
      iconActive={<AppearanceActiveSvg />}
      description={
        <FormattedMessage
          id="dating_profile.appearance"
          defaultMessage="Внешность"
        />
      }
      fieldType={ProfileFieldType.Single}
      lexemes={lexemes}
      data-name={FIELD_PATH_APPEARANCE}
      data={data}
    />
  )
}
